import { createSlice } from "@reduxjs/toolkit"
import locationApiSlice from "services/locationApiSlice"
import * as _ from "lodash"
const initialState = {
  locations: [],
  canAddLocation: true,
}

const locationSlice = createSlice({
  name: "locations",
  initialState,
  reducers: {
    addRemoveLocation: (state, action) => {
      if (state.canAddLocation) {
        state.locations.unshift({ _id: new Date().getTime() })
        state.canAddLocation = false
      } else {
        state.locations.shift()
        state.canAddLocation = true
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      locationApiSlice.endpoints.fetchLocations.matchFulfilled,
      (state, action) => {
        state.locations = action.payload
      }
    )
    builder.addMatcher(
      locationApiSlice.endpoints.fetchLocations.matchRejected,
      (state, action) => {
        state.locations = []
      }
    )
    builder.addMatcher(
      locationApiSlice.endpoints.updateLocation.matchFulfilled,
      (state, action) => {
        const index = state.locations.findIndex(
          (item) => item?._id == action.payload?._id
        )
        if (index != -1) {
          state.locations[index] = action.payload
        }
      }
    )

    builder.addMatcher(
      locationApiSlice.endpoints.addLocation.matchFulfilled,
      (state, action) => {
        state.locations[0] = action.payload
        state.canAddLocation = true
      }
    )
    builder.addMatcher(
      locationApiSlice.endpoints.addLocation.matchRejected,
      (state, action) => {
        state.canAddLocation = true
      }
    )

    builder.addMatcher(
      locationApiSlice.endpoints.deleteLocation.matchFulfilled,
      (state, action) => {
        const deletedLocations = action.payload.deletedLocations
        state.locations = state.locations.filter((location) => {
          return !deletedLocations.includes(location?._id)
        })
      }
    )
  },
})

export default locationSlice.reducer
export const { addRemoveLocation } = locationSlice.actions
